export default "__VITE_ASSET__8b0d1385__"